import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const useTransformedParams = () => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const params = new URLSearchParams(searchParams);

    // Transform groups → groupIds
    if (params.has("groups")) {
      const groupIds = params.get("groups");
      params.delete("groups");
      if (groupIds) {
        params.set("groupIds", groupIds);
      }
    }

    // Handle other transformations if needed
    // Example: status → statusIds, priority → priorityIds

    return Object.fromEntries(params);
  }, [searchParams]);
};
